module.exports = __webpack_public_path__ + "static/media/navigation-icons-profile-organization-profile.05160faf.svg";